/* eslint-disable no-unused-vars */
import React from "react";
import { Button, FormTextInput } from "../../../components";
import { colors } from "../../../configs";
import Strings from "../../../translations";

const CommoditiesForm = (props) => {
  const {
    errorMessage,
    setMessage,
    handleChangeFormData = () => {},
    initialValue = {},
    actionType,
    handleModalClose,
  } = props;

  const createProductAndServicesTitle =
      Strings["Commodities.createCommoditiesTitle"],
    editProductAndServicesTitle = Strings["Commodities.editCommoditiesTitle"],
    productAndServicesNameLabel = Strings["Commodities.CommoditiesNameLabel"],
    productAndServicesNamePlaceholder =
      Strings["Commodities.CommoditiesNamePlaceholder"],
    productAndServicesNameCustomError =
      Strings["Commodities.CommoditiesNameCustomError"],
    productAndServicesDescriptionLabel =
      Strings["Commodities.CommoditiesDescriptionLabel"],
    productAndServicesDescriptionPlaceholder =
      Strings["Commodities.CommoditiesDescriptionPlaceholder"],
    productAndServicesDescriptionCustomError =
      Strings["Commodities.CommoditiesDescriptionCustomError"],
    productAndServicesSaveBtn = Strings["Commodities.CommoditiesSaveBtn"],
    productAndServicesUpdateBtn = Strings["Commodities.CommoditiesUpdateBtn"],
    productAndServicesCancelBtn = Strings["Commodities.CommoditiesCancelBtn"];

  const [name, setName] = React.useState({
    value: initialValue.name ? initialValue.name : "",
    error: false,
    sucess: false,
  });

  const [description, setDescription] = React.useState({
    value: initialValue.description ? initialValue.description : "",
    error: false,
    sucess: false,
  });

  const handleChangeName = (value) => {
    setMessage(null);
    setName(value);
  };

  const handleChangeDescription = (value) => {
    setDescription(value);
  };

  const handleSaveData = () => {
    const formData = {
      name: name.value,
      description: description.value,
    };
    handleChangeFormData(formData);
  };

  let isValueChanged = name.value === initialValue.name;
  // description.value === initialValue.description

  let disable =
    name.error ||
    // description.error ||
    name.value === "" ||
    // description.value === "" ||
    name.sucess === false ||
    isValueChanged;

  //edit
  let isValueChangededit =
    name.value === initialValue.name &&
    description.value === initialValue.description;

  let Editdisable =
    name.error ||
    description.error ||
    name.value === "" ||
    description.value === "" ||
    (name.success === false && description.success) ||
    isValueChangededit;

  return (
    <div className="modalFormContainer">
      <h2>
        {actionType === "add"
          ? createProductAndServicesTitle
          : editProductAndServicesTitle}
      </h2>
      {errorMessage && <h6 style={{ color: "red" }}>{errorMessage}</h6>}
      <FormTextInput
        type="alpha"
        starProps={true}
        label={productAndServicesNameLabel}
        placeholder={productAndServicesNamePlaceholder}
        Value={name.value}
        onChangeText={handleChangeName}
        Validate={true}
        CustomErrorLine={productAndServicesNameCustomError}
        editable
        maxLength={30}
      />
      <FormTextInput
        type="alpha"
        label={productAndServicesDescriptionLabel}
        placeholder={productAndServicesDescriptionPlaceholder}
        Value={description.value}
        onChangeText={handleChangeDescription}
        Validate={false}
        CustomErrorLine={productAndServicesDescriptionCustomError}
        multiline={true}
        editable
        maxLength={50}
      />

      <div style={{ display: "flex", marginTop: "1.5rem" }}>
        <Button
          buttonName={
            actionType === "add"
              ? productAndServicesSaveBtn
              : productAndServicesUpdateBtn
          }
          buttonStyle={{ backgroundColor: colors.primary }}
          disable={actionType === "add" ? disable : Editdisable}
          onClick={handleSaveData}
        />
        <Button
          buttonName={productAndServicesCancelBtn}
          buttonStyle={{ backgroundColor: colors.darkgrey, marginLeft: "10px" }}
          onClick={() => {
            setMessage(null);
            handleModalClose();
          }}
        />
      </div>
    </div>
  );
};

export default CommoditiesForm;
